import { render, staticRenderFns } from "./group-relationship-batch-detail.vue?vue&type=template&id=0b2572e3&scoped=true"
import script from "./group-relationship-batch-detail.vue?vue&type=script&lang=js"
export * from "./group-relationship-batch-detail.vue?vue&type=script&lang=js"
import style0 from "./group-relationship-batch-detail.vue?vue&type=style&index=0&id=0b2572e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2572e3",
  null
  
)

export default component.exports